export const UserGuideModel = Symbol.for('UserGuideModel');
